import { DeleteCorporateClientState, DeleteCorporateClientActionTypes, DELETE_CORPORATE_CLIENT_REQUEST, DELETE_CORPORATE_CLIENT_SUCCESS, DELETE_CORPORATE_CLIENT_FAILURE } from "store/reducers/corporate-client/delete-corporate-client/types";

const defaultState: DeleteCorporateClientState = {
  isLoading: false,
  errorMessage: ""
};

export default function deleteCorporateClient(state = defaultState, action: DeleteCorporateClientActionTypes): DeleteCorporateClientState {
  switch (action.type) {
    case DELETE_CORPORATE_CLIENT_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case DELETE_CORPORATE_CLIENT_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case DELETE_CORPORATE_CLIENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};